import React, { useState, useEffect, useContext } from 'react';
import { Box, Typography, Button, CircularProgress, Paper } from '@mui/material';
import { requestViderConnectAccess, checkViderConnectAccess } from 'api/services/vider-connect';
import { UserProfileContext } from 'context/UserProfile';
import { viderconnectlogo } from 'assets';

const RequestViderConnectAccess = () => {
  const [status, setStatus] = useState<'LOADING' | 'NONE' | 'REQUESTED' | 'APPROVED'>('LOADING');
  const [loading, setLoading] = useState(false);
  const { data: uData } = useContext(UserProfileContext);

  useEffect(() => {
    const fetchAccess = async () => {
      try {
        const res: any = await checkViderConnectAccess();
        const access = res?.data?.access;

        if (access === 'REQUESTED') {
          setStatus('REQUESTED');
        } else if (access === 'APPROVED') {
          setStatus('APPROVED');
        } else {
          setStatus('NONE');
        }
      } catch (err) {
        setStatus('NONE');
      }
    };
    fetchAccess();
  }, []);

  const handleRequest = async () => {
    try {
      setLoading(true);
      await requestViderConnectAccess({ access: 'REQUESTED', organizationId: uData?.organization?.id });
      setStatus('REQUESTED');
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // 🔁 Auto check if approved
  // useEffect(() => {
  //   if (status !== 'REQUESTED') return;

  //   const interval = setInterval(async () => {
  //     try {
  //       const res: any = await checkViderConnectAccess();

  //       if (res.data.access === 'APPROVED') {
  //         window.location.reload(); // simplest refresh
  //       }
  //     } catch (err) {
  //       console.error(err);
  //     }
  //   }, 5000);

  //   return () => clearInterval(interval);
  // }, [status]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="80vh"
      gap={2}
    >
      {status !== 'NONE' && (
        <Typography variant="h5" fontWeight={600}>
          Vider Connect Access
        </Typography>
      )}

      {status === 'LOADING' && (
        <CircularProgress />
      )}

      {status === 'NONE' && (
        <>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="100vh"
            sx={{ p: 2 }}
          >
            <Paper
              elevation={6}
              sx={{
                width: 650,
                borderRadius: 5,
                p: 4,
                textAlign: "center",
                background: "#f8fafc"
              }}
            >
              {/* LOGO */}
              <Box
              >
                <img src={viderconnectlogo} alt="viderconnectlogo" style={{ width: 100, height: 100 }} />
              </Box>

              {/* TITLE */}
              <Typography variant="h4" fontWeight={700} color="#182F53">
                Vider Connect
              </Typography>

              <Typography mt={2} color="text.secondary">
                Break the 4-Device Barrier. Unlimited WhatsApp Access for Your Entire Team.
              </Typography>

              {/* FEATURES BOX */}
              <Box
                sx={{
                  mt: 4,
                  p: 3,
                  borderRadius: 3,
                  background: "#eef3f8",
                  textAlign: "left"
                }}
              >
                <Typography fontWeight={600} mb={1}>
                  ♾️ Unlimited Team Members
                </Typography>
                <Typography variant="body2" color="text.secondary" mb={2}>
                  No more device limits — everyone gets access
                </Typography>

                <Typography fontWeight={600} mb={1}>
                  ✅ Message Attribution
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Know exactly who sent every message to clients
                </Typography>
              </Box>

              {/* BUTTON */}
              <Button
                fullWidth
                variant="contained"
                onClick={handleRequest}
                disabled={loading}
                sx={{
                  mt: 4,
                  py: 1.5,
                  borderRadius: 3,
                  fontSize: 16,
                  fontWeight: 600,
                  background: "#182F53"
                }}
              >
                {loading ? <CircularProgress size={20} color="inherit" /> : "Request Now →"}
              </Button>

              {/* FOOTER */}
              <Typography mt={3} variant="body2" color="text.secondary">
                Questions? Contact us at{" "}
                <span style={{ color: "#182F53" }}>support@vider.in</span>
              </Typography>
            </Paper>
          </Box>



        </>
      )}

      {status === 'REQUESTED' && (
        <>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="100vh"
            sx={{ p: 2 }}
          >
            <Paper
              elevation={6}
              sx={{
                width: 650,
                borderRadius: 5,
                p: 4,
                textAlign: "center",
                background: "#f8fafc"
              }}
            >
              {/* LOGO */}
              <Box
              >
                <img src={viderconnectlogo} alt="viderconnectlogo" style={{ width: 100, height: 100 }} />
              </Box>

              {/* TITLE */}
              <Typography variant="h5" fontWeight={700} color="#182F53">
                Subscription Request Received
              </Typography>

              <Typography mt={2} color="text.secondary">
                Thankyou for subscribing to Vider Connect.
              </Typography>

              {/* FEATURES BOX */}
              <Box
                sx={{
                  mt: 4,
                  p: 3,
                  borderRadius: 3,
                  background: "#eef3f8",
                  textAlign: "left"
                }}
              >
                <Typography fontWeight={600} mb={1}>
                  Status: Pending Approval
                </Typography>
                <Typography variant="body2" color="text.secondary" mb={2}>
                  Your request is being reviewed.We'll notify you once it's approved.
                </Typography>


              </Box>



            </Paper>
          </Box>



        </>
      )}
    </Box>
  );
};

export default RequestViderConnectAccess;